import { useEffect, useRef } from 'react';
import { getUserNotifyList } from '@/services/user';
import { useUserStore } from '@/stores/user';
import { useUserNotifyStore } from '@/stores/userNotify';

const SILENT_NOTIFY_REQUEST_CONFIG = {
  hideCodeErrorMessage: true,
  hideHTTPErrorMessage: true,
};

/**
 * 通知初始化 Hook
 * 负责在登录时自动获取通知列表
 */
export function useNotifyInit() {
  const initialized = useUserNotifyStore(state => state.initialized);
  const isLoading = useUserNotifyStore(state => state.isLoading);
  const isLogin = useUserStore(state => state.isLogin);
  const requestedRef = useRef(false);

  useEffect(() => {
    const { setInitialized, setLoading, setNotifyList } = useUserNotifyStore.getState();

    const isMaintenance = window.location.pathname.includes('/maintenance');

    if (!isLogin) {
      requestedRef.current = false;
      return;
    }

    if (initialized || isLoading || isMaintenance || requestedRef.current) {
      return;
    }

    const fetchNotifyList = async () => {
      try {
        requestedRef.current = true;
        setLoading(true);
        const res = await getUserNotifyList(SILENT_NOTIFY_REQUEST_CONFIG);
        setNotifyList(res.data.notifyList);
      } catch (err) {
        console.warn('Failed to fetch notify list:', err);
        setInitialized(true);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifyList();
  }, [initialized, isLoading, isLogin]);
}
